import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/static/images/icon/info_error.svg")